<template>
  <div class="field">
    <label class="label">Message</label>
    <div class="control">
      <textarea
        class="textarea is-fullwidth"
        placeholder="Message"
        v-model="message"
        @input="handleInput"
        :maxlength="lengthLimit"
        style="color: #00a651;"
      ></textarea>
      <div class="m-0 mt-1 p-0 is-flex is-justify-content-space-between is-align-items-center">
        <div>
          <button class="button is-small is-info" @click="handleClick">Submit</button>
        </div>
        <div class="is-size-7">{{ message.length }} / {{ lengthLimit }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicantMessage',
  props: {
    value: {
      type: String,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    applicantId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      lengthLimit: 350,
      oldMessage: '',
      message: ''
    }
  },
  created () {
    this.initializeMessage()
  },
  watch: {
    value () {
      this.initializeMessage()
    },
    message (newValue) {
      if (newValue.length > this.lengthLimit) {
        this.message = newValue.slice(0, this.lengthLimit)
      }
    }
  },
  methods: {
    initializeMessage () {
      this.message = this.removeMeta(this.value)
      this.oldMessage = this.removeMeta(this.value)
    },
    removeMeta (message) {
      return message.replace(/<message-meta>[\s\S]*?<\/message-meta>/g, '').trim()
    },
    appendMeta () {
      const messageDate = new Date().toISOString()
      const ownerName = this.$utils.getOwner().name
      return `<message-meta><message-date>${messageDate}</message-date><owner>${ownerName}</owner></message-meta>`
    },
    async handleInput () {
      const messageWithMeta = `${this.message}\n${this.appendMeta()}`
      try {
        await this.$caller.request('put', `/users/${this.userId}`, 'admin_headers', { message: messageWithMeta })
        await this.$network_utils.updateApplicant({ applicant_id: this.applicantId, active_at: new Date() })
      } catch (error) {
        console.error('Failed to save message:', error)
      }
    },
    handleClick () {
      const stat_content = 'Message Changed:<br><b>Old Message was:</b> ' + this.oldMessage + '<br><b>New Message is:</b> ' + this.message
      this.$network_utils.postStat({
        title: 'new internal note',
        designator: 'internal_notes',
        content: stat_content,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 7,
        resource_id: this.applicantId,
        resource_type: 'Applicant'
      })
    }
  }
}
</script>
